export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/engine.84a0c2d0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};